export const dashboardTabs = [
    'Início',
    'Agendamentos',
    'Equipa Técnica',
    'Cuidadores e Pacientes',
    'Documentos'
];

export const missedCalls = [
    {
        id: 'c1',
        name: 'Ilda Henriques',
        date: '21/10/2023 23:33',
        tags: ['AG', 'ML', 'RP'],
        urgent: true
    },
    {
        id: 'c2',
        name: 'Ant?nio Sousa',
        date: '21/10/2023 23:33',
        tags: ['AG', 'ML', 'RP'],
        urgent: true
    },
    {
        id: 'c3',
        name: 'Maria do C?u',
        date: '21/10/2023 23:33',
        tags: ['AG', 'ML', 'RP'],
        urgent: false
    },
    {
        id: 'c4',
        name: 'Margarida Amorim',
        date: '21/10/2023 23:33',
        tags: ['AG', 'ML', 'RP'],
        urgent: false
    }
];
